import placeholderImage from '../assets/fallback-headshot-4_3.png';

/**
 * Gets the ODIR image URL with the correct
 * width & tenant params
 *
 * @param {string} imgUrl image base URL
 * @param {number} [width] image width
 * @param height
 * @returns {string} odir image URL with width and tenant
 */
export const getImageUrl = (imgUrl, width = '', height = null) => {
    if (imgUrl?.includes('blob:')) {
        return imgUrl;
    }

    const tenant = window?.PLAYBOOK_CONFIG?.tenant
        ? window.PLAYBOOK_CONFIG.tenant
        : window?.PLAYBOOK_TENANT;

    if (height) {
        return `${imgUrl}?width=${width}&height=${height}&tenant=${tenant}`;
    }

    return `${imgUrl}?width=${width}&tenant=${tenant}`;
};

/**
 * On error image helper/handler
 * Sets a placeholder image if the image fails to load
 *
 * @param {object} event the browser event
 * @returns {void} sets the image src to a placeholder on error
 */
export const onErrorImage = (event) => {
    event.target.src = placeholderImage;
};
